import type {Messages} from "i18n/en";
import type {PeelDialogKind} from "./peelTagSlot";

/** What a tag that opens in a dialog says: its icon tab's accessible name, and the dialog's title. */
export interface PeelDialogCopy {
	openLabel: string;
	title: string;
}

/**
 * The words on a phone's tab and over the dialog it opens, for each kind of tag that opens in one
 * (ui#3343, ui#3372). One table, read by the slot that renders them and by the e2e helpers that find
 * them, so the two cannot name a tag differently.
 */
export function peelDialogCopy(messages: Messages, kind: PeelDialogKind): PeelDialogCopy {
	switch (kind) {
		case "coupon":
			return {openLabel: messages.offerLadder.gift.openAria, title: messages.offerLadder.gift.ticketDialogTitle};
		case "invite":
			return {openLabel: messages.sender.referral.openAria, title: messages.sender.referral.dialogTitle};
		case "recipientGift":
			return {openLabel: messages.download.referralOffer.openAria, title: messages.download.referralOffer.dialogTitle};
	}
}
